import { render, staticRenderFns } from "./mapChooseGroup.vue?vue&type=template&id=3f0d67b1&scoped=true&"
import script from "./mapChooseGroup.vue?vue&type=script&lang=ts&"
export * from "./mapChooseGroup.vue?vue&type=script&lang=ts&"
import style0 from "./mapChooseGroup.vue?vue&type=style&index=0&id=3f0d67b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d67b1",
  null
  
)

export default component.exports